<div>
  <div class="bar-track"></div>
</div>
